import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  standalone: false,
  name: 'isoToNgbDate'
})
export class IsoToNgbDatePipe implements PipeTransform {
  transform(isoDate: string): any {
    const ngbDate = isoDate
      ? { year: moment(isoDate).year(), month: moment(isoDate).month() + 1, day: moment(isoDate).date() }
      : isoDate;
    return ngbDate;
  }
}
